<a 
  *ngIf="href; else divElement"
  [href]="href"
  class="menuItem"
  [ngClass]="menuItemClasses"
  [attr.data-disabled]="dataAttributes['data-disabled']"
  [attr.data-selected]="dataAttributes['data-selected']"
  [attr.data-has-submenu]="dataAttributes['data-has-submenu']"
  [attr.data-is-destructive]="dataAttributes['data-is-destructive']"
  [attr.data-is-mcp]="dataAttributes['data-is-mcp']"
  tabindex="0">
  <ng-content></ng-content>
  <app-titan-icon
    *ngIf="hasSubmenu"
    [variant]="'Right'" [size]="'m'">
  </app-titan-icon>
</a>

<ng-template #divElement>
  <div
    class="menuItem"
    [ngClass]="menuItemClasses"
    [attr.data-disabled]="dataAttributes['data-disabled']"
    [attr.data-selected]="dataAttributes['data-selected']"
    [attr.data-has-submenu]="dataAttributes['data-has-submenu']"
    [attr.data-is-destructive]="dataAttributes['data-is-destructive']"
    [attr.data-is-mcp]="dataAttributes['data-is-mcp']"
    tabindex="0"
    role="menuitem">
    <ng-content></ng-content>
    <app-titan-icon 
      *ngIf="hasSubmenu" 
      [variant]="'Right'" [size]="'m'">
    </app-titan-icon>
  </div>
</ng-template>
